import amazonUnpackedPageMeta from './amazon_unpacked_seo_util';

export default function(state = {}, action = {}) {
  return amazonUnpackedPageMeta(state, action);
}
